import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DeveloperKeysIcon = ({
  title
}) => {
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-test-id": "vertical-nav-icon__developer-keys",
    children: [title ? /*#__PURE__*/_jsx("title", {
      children: title
    }) : null, /*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0_136_747)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0.553517 0.520578C0.303117 0.711673 0.26358 0.889589 0.38878 1.45629C0.51398 2.02298 0.764381 4.28318 2.20748 5.0871C3.65058 5.89102 5.69332 3.8944 4.79715 2.47766C3.90098 1.06092 2.30632 1.52877 1.81211 1.06092C1.3179 0.593062 1.0675 0.197692 0.553517 0.520578ZM6.50383 4.28318L6.53678 4.31613C6.74764 4.52699 6.74764 4.86305 6.53678 5.07392L4.90917 6.70152C4.69831 6.91239 4.36225 6.91239 4.15138 6.70152L4.11843 6.66858C3.90757 6.45771 3.90757 6.12165 4.11843 5.91078L5.74604 4.28318C5.9569 4.07231 6.29956 4.07231 6.50383 4.28318ZM15.5578 13.3174L10.0753 7.84151L12.3817 5.53518C12.5464 5.56813 12.7441 5.5879 12.9352 5.5879C14.4837 5.5879 15.7357 4.3293 15.7357 2.78077V2.76759C15.7357 2.41176 15.6698 2.0757 15.5578 1.76599L14.2069 3.08389C14.0224 3.2684 13.7655 3.3936 13.4755 3.3936C13.1922 3.3936 12.9352 3.27499 12.7441 3.08389C12.5266 2.86644 12.3817 2.55673 12.3817 2.21408C12.3817 1.87142 12.52 1.56831 12.7441 1.34426L13.9434 0.184513C13.6403 0.0659025 13.2976 7.62939e-06 12.9286 7.62939e-06C11.3801 7.62939e-06 10.1215 1.2586 10.1215 2.80713C10.1215 2.99164 10.1412 3.17614 10.1742 3.34747L10.1676 3.3277L7.86127 5.63402L7.53179 5.30455L5.36385 7.56475L5.65379 7.84809L0.454675 13.0538C0.171327 13.3437 0 13.7259 0 14.1542C0 15.0175 0.705076 15.716 1.56171 15.716C1.99003 15.716 2.3854 15.5446 2.66216 15.2547L7.85468 10.0556L13.3371 15.5249C13.6205 15.8082 14.0093 15.9795 14.4376 15.9795C15.3008 15.9795 15.9993 15.2745 15.9993 14.4178C16.0125 13.9895 15.8411 13.5941 15.5578 13.3174ZM1.31131 14.8264C1.09386 14.8264 0.90935 14.655 0.90935 14.4244C0.90935 14.207 1.08727 14.029 1.31131 14.029C1.52876 14.029 1.71327 14.2004 1.71327 14.4244C1.71327 14.6485 1.53535 14.8264 1.31131 14.8264Z",
        fill: "#DFE3EB"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_136_747",
        children: /*#__PURE__*/_jsx("rect", {
          width: "16",
          height: "16",
          fill: "white"
        })
      })
    })]
  });
};
export default DeveloperKeysIcon;